<div class="sdps-navigation--horizontal">
  <nav aria-label="Reports sub-navigation"
       class="sdps-navigation--horizontal__levelFour subNavigation" id="unique-secondaryNav">
    <ul class="sdps-navigation--horizontal__nav">
        <li class="sdps-navigation--horizontal__item" routerLinkActive="sdps-is-active" *ngFor="let nav of reportsSubMenu">
          <a class="sdps-navigation--horizontal__link">
            <button class="buttons sub-navigation-button" [routerLink]="nav.route" [innerHTML]="nav.name"
                    (click)="sharedService.loadDataTrackValue(nav.route)"></button>
          </a>
        </li>
    </ul>
  </nav>

  <div class="content-area sdps-p-around_large">
    <ems-service-error *ngIf="(sharedService.showHistoricalView | async) || (sharedService.errorMessage | async)"></ems-service-error>
    <router-outlet></router-outlet>
  </div>
</div>
